import { Injectable } from "@angular/core";
import {
  Http,
  Headers,
  RequestOptions,
  Response,
  URLSearchParams,
} from "@angular/http";
import { AuthHttp } from "angular2-jwt";
import { Observable } from "rxjs/Observable";
import "rxjs/add/operator/map";
import "rxjs/add/operator/catch";
import "rxjs/add/observable/throw";

import { Config } from "../config";
import { AuthenticationService } from "../services/authentication.service";
import { Department } from "../shared/models/department.model";
import { User } from "../shared/models/user.model";

/**
 * Administration service (to Identity Web API controller).
 */
@Injectable()
export class AdministrationService {
  headers: Headers;
  options: RequestOptions;

  constructor(
    private authHttp: AuthHttp,
    private http: Http,
    private authenticationService: AuthenticationService
  ) {
    // Creates header for post requests.
    this.headers = new Headers({ "Content-Type": "application/json" });
    this.options = new RequestOptions({ headers: this.headers });
  }

  /**
   * Get all departments
   */
  public getAllDepartments(): Observable<Department[]> {
    let params: URLSearchParams = new URLSearchParams();
    params.set("adminId", this.authenticationService.userSubject.value.sub);
    let cb = new Date().getTime();
    params.set("cacheBuster", cb.toString());
    this.options.search = params;
    return this.authHttp
      .get(
        Config.BaseUrl + "/api/Administration/GetAllDepartments",
        this.options
      )
      .map((res: Response) => {
        return res.json();
      })
      .catch((error: any) => {
        return Observable.throw(error);
      });
  }

  /**
   * Create a new department
   * @param department
   */
  public createDepartment(department: Department): Observable<Department> {
    let params: URLSearchParams = new URLSearchParams();
    params.set("adminId", this.authenticationService.userSubject.value.sub);
    this.options.search = params;
    let body: Department = department;
    return this.authHttp
      .post(
        Config.BaseUrl + "/api/Administration/CreateDepartment",
        body,
        this.options
      )
      .map((res: Response) => {
        return res.json();
      })
      .catch((error: any) => {
        return Observable.throw(error);
      });
  }

  /**
   * Update single department
   * @param department
   */
  public updateDepartment(department: Department): Observable<Department> {
    let params: URLSearchParams = new URLSearchParams();
    params.set("adminId", this.authenticationService.userSubject.value.sub);
    this.options.search = params;
    let body: Department = department;
    return this.authHttp
      .post(
        Config.BaseUrl + "/api/Administration/UpdateDepartment",
        body,
        this.options
      )
      .map((res: Response) => {
        return res.json();
      })
      .catch((error: any) => {
        return Observable.throw(error);
      });
  }

  /**
   * Delete single department
   * @param department
   */
  public deleteDepartment(department: Department): Observable<Department> {
    let params: URLSearchParams = new URLSearchParams();
    params.set("adminId", this.authenticationService.userSubject.value.sub);
    this.options.search = params;
    let body: Department = department;
    return this.authHttp
      .post(
        Config.BaseUrl + "/api/Administration/DeleteDepartment",
        body,
        this.options
      )
      .map((res: Response) => {
        return res.json();
      })
      .catch((error: any) => {
        return Observable.throw(error);
      });
  }

  /**
   * Get all roles available
   */
  public getAllRoles() {
    let params: URLSearchParams = new URLSearchParams();
    params.set("adminId", this.authenticationService.userSubject.value.sub);
    let cb = new Date().getTime();
    params.set("cacheBuster", cb.toString());
    this.options.search = params;
    return this.authHttp
      .get(Config.BaseUrl + "/api/Administration/GetAllRoles", this.options)
      .map((res: Response) => {
        return res.json();
      })
      .catch((error: any) => {
        return Observable.throw(error);
      });
  }

  /**
   * Get all existing users
   */
  public getAllUsers() {
    let params: URLSearchParams = new URLSearchParams();
    params.set("adminId", this.authenticationService.userSubject.value.sub);
    let cb = new Date().getTime();
    params.set("cacheBuster", cb.toString());
    this.options.search = params;
    return this.authHttp
      .get(Config.BaseUrl + "/api/Administration/GetAllUsers", this.options)
      .map((res: Response) => {
        return res.json();
      })
      .catch((error: any) => {
        return Observable.throw(error);
      });
  }

  /**
   *
   * @param user Create a new user
   */
  public createUser(user: User): Observable<User> {
    let params: URLSearchParams = new URLSearchParams();
    params.set("adminId", this.authenticationService.userSubject.value.sub);
    this.options.search = params;
    let body: User = user;
    return this.authHttp
      .post(Config.BaseUrl + "/api/Identity/Create", body, this.options)
      .map((res: Response) => {
        return res.json();
      })
      .catch((error: any) => {
        return Observable.throw(error);
      });
  }

  public updateUserActive(user: User): Observable<User> {
    let params: URLSearchParams = new URLSearchParams();
    params.set("adminId", this.authenticationService.userSubject.value.sub);
    this.options.search = params;
    let body: User = user;
    return this.authHttp
      .post(Config.BaseUrl + "/api/Identity/Update", body, this.options)
      .map((res: Response) => {
        return res.json();
      })
      .catch((error: any) => {
        return Observable.throw(error);
      });
  }

  public editUser(user): Observable<User> {
    console.log(user);
    let updatedUser = new User();
    updatedUser.active = user.active;
    updatedUser.departments = user.departments;
    updatedUser.email = user.email;
    updatedUser.id = user.id;
    updatedUser.password = user.password;
    updatedUser.role = user.roleobj.name;
    updatedUser.username = user.userName;
    let params: URLSearchParams = new URLSearchParams();
    params.set("adminId", this.authenticationService.userSubject.value.sub);
    this.options.search = params;
    let body: User = updatedUser;
    return this.authHttp
      .post(Config.BaseUrl + "/api/Identity/Update", body, this.options)
      .map((res: Response) => {
        return res.json();
      })
      .catch((error: any) => {
        return Observable.throw(error);
      });
  }

  public editUserPassword(user): Observable<User> {
    console.log(user);
    let updatedUser = new User();
    updatedUser.id = user.id;
    updatedUser.password = user.password;
    updatedUser.username = user.userName;
    let params: URLSearchParams = new URLSearchParams();
    params.set("adminId", this.authenticationService.userSubject.value.sub);
    this.options.search = params;
    let body: User = updatedUser;
    return this.authHttp
      .post(Config.BaseUrl + "/api/Identity/UpdatePassword", body, this.options)
      .map((res: Response) => {
        return res.json();
      })
      .catch((error: any) => {
        return Observable.throw(error);
      });
  }

  public deleteUser(username: string): Observable<string> {
    let body: string = JSON.stringify(username);
    return this.authHttp
      .post(Config.BaseUrl + "/api/Identity/Delete", body, this.options)
      .map((res: Response) => {
        return res.json();
      })
      .catch((error: any) => {
        return Observable.throw(error);
      });
  }
}
